// 追加行で使う内部状態（氏名選択 => 自動で code を反映するやつ）
export interface NewAssignmentSelection {
  employeeId: number;
  code: string;
  name: string;
}

export const EmptyNewAssignmentSelection: NewAssignmentSelection = {
  employeeId: 0,
  code: '',
  name: '',
};
